module.exports = __webpack_public_path__ + "img/deletePhoto.71e0e52c.svg";